module.exports = __webpack_public_path__ + "static/img/Gloves PU products application horizontal_desktop.c76ddb46.jpg";